import { MediumLargeViewportOnly } from "../ViewportOnly";
import HorizontalRefinements from "../HorizontalRefinements";

const MediumLargeScreenHeader = () => (
  <MediumLargeViewportOnly>
    <HorizontalRefinements />
  </MediumLargeViewportOnly>
);

export default MediumLargeScreenHeader;
